module.exports = __webpack_public_path__ + "img/academy-logo-black.baa3a758.svg";